import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Form } from "react-bootstrap";
import "./hm-theme.css";

const RefundAmount = ({ isOpen, onRequestClose, payment }) => {
  const [appointments, setAppointments] = useState(null);
  const [refundAmount, setRefundAmount] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (payment) {
      fetchAppointmentData(payment.paymentId);
    }
  }, [payment]);

  const fetchAppointmentData = async (paymentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      const response = await axios.post(`/api/employeeappointment/getAppointsByRazorPaymentId`,
        { paymentId: paymentId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAppointments(response.data);
      const refund = payment.platformFee !== null
        ? (payment.amount - payment.platformFee).toFixed(2)
        : payment.amount.toFixed(2);
      setRefundAmount(parseFloat(refund));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleRefund = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      const response = await axios.post('/api/employeeappointment/cancel-and-refund', {
        appointmentId: appointments?.id,
        razorpayPaymentId: payment?.paymentId,
        refundAmount: refundAmount
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(response.data);
      onRequestClose();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.response?.data || error.message || "An error occurred.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">money_off</i>
          Refund Payment Amount
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}

        <div className="mb-3 p-3 rounded-3 d-flex align-items-start gap-3" style={{ background: "rgba(220,53,69,0.06)", border: "1px solid rgba(220,53,69,0.2)" }}>
          <i className="material-icons text-danger mt-1" style={{ fontSize: "1.4rem" }}>monetization_on</i>
          <div>
            <p className="fw-semibold mb-1">Process Full Refund?</p>
            <p className="text-muted small mb-0">Are you sure you want to refund this amount to the customer's original payment method?</p>
          </div>
        </div>

        {payment && (
          <div className="mb-4">
            <Form.Label className="small fw-semibold">Refund Amount</Form.Label>
            <div className="input-group">
              <span className="input-group-text" style={{ background: "#f1f5f9" }}>₹</span>
              <Form.Control
                type="text"
                value={refundAmount !== null ? refundAmount : ""}
                readOnly
                className="fw-bold fs-5 text-primary"
              />
            </div>
            <Form.Text className="text-muted small">Full refund amount.</Form.Text>
          </div>
        )}

        <div className="d-flex justify-content-end gap-2">
          <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
            Cancel
          </Button>
          <button
            className="btn btn-danger rounded-pill px-4 d-flex align-items-center gap-1"
            onClick={handleRefund}
            disabled={loading}
          >
            <i className="material-icons" style={{ fontSize: "1rem" }}>money_off</i>
            Confirm Refund
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RefundAmount;
